/**
 * Auth Api
 * Auth Xpo Api which handles all the api restful calls
 *
 * OpenAPI spec version: v3.0.1.0
 * Contact: ea@xpo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { Application } from '../model/application';
import { ApplicationRequest } from '../model/applicationRequest';
import { ApplicationSearchResult } from '../model/applicationSearchResult';
import { ApplicationSearchResults } from '../model/applicationSearchResults';
import { SearchRequest } from '../model/searchRequest';
import { UserApplicationsRequest } from '../model/userApplicationsRequest';
import { ValidationResult } from '../model/validationResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ApplicationsService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Applications - By Id
     * This is for getting the Application by ApplicationId                Sample request:                GET /applications/23b59143-0c04-424f-b69d-16533401f21b
     * @param appId The application guid id.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsAppIdGet(appId: string, observe?: 'body', reportProgress?: boolean): Observable<Application>;
    public applicationsAppIdGet(appId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Application>>;
    public applicationsAppIdGet(appId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Application>>;
    public applicationsAppIdGet(appId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling applicationsAppIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Application>(`${this.configuration.basePath}/Applications/${encodeURIComponent(String(appId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applications - Update Identity Providers
     * This is for updating a new Application                Sample request:                PUT /applications                [\&quot;\&quot;, \&quot;\&quot;]
     * @param appId The application Id.
     * @param requestBody The identity provider ids.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsAppIdIdentityProvidersPut(appId: string, requestBody?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Application>;
    public applicationsAppIdIdentityProvidersPut(appId: string, requestBody?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Application>>;
    public applicationsAppIdIdentityProvidersPut(appId: string, requestBody?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Application>>;
    public applicationsAppIdIdentityProvidersPut(appId: string, requestBody?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling applicationsAppIdIdentityProvidersPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Application>(`${this.configuration.basePath}/Applications/${encodeURIComponent(String(appId))}/identity-providers`,
            requestBody,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applications - Soft Delete
     * Soft Deletes Application by ApplicationId                Sample request:                DELETE /applications/23b59143-0c04-424f-b69d-16533401f21b/true
     * @param appId The application id.
     * @param isDeleted The is deleted true or false.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsAppIdIsDeletedDelete(appId: string, isDeleted: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public applicationsAppIdIsDeletedDelete(appId: string, isDeleted: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public applicationsAppIdIsDeletedDelete(appId: string, isDeleted: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public applicationsAppIdIsDeletedDelete(appId: string, isDeleted: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling applicationsAppIdIsDeletedDelete.');
        }
        if (isDeleted === null || isDeleted === undefined) {
            throw new Error('Required parameter isDeleted was null or undefined when calling applicationsAppIdIsDeletedDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.configuration.basePath}/Applications/${encodeURIComponent(String(appId))}/${encodeURIComponent(String(isDeleted))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applications - Update
     * This is for updating a new Application                Sample request:                PUT /applications                {                    \&quot;FlowTypeId\&quot;: 1,                    \&quot;Name\&quot;: \&quot;sample\&quot;,                    \&quot;Description\&quot;: null,                    \&quot;ImageBundleId\&quot;: 1,                    \&quot;GrantTypes\&quot;: [1, 2],                    \&quot;SupportContactEmail\&quot;: null,                    \&quot;ApplicationTypeId\&quot;: 1,                    \&quot;AccessTokenLifetime\&quot;: 50,                    \&quot;AllowOfflineAccess\&quot;: false,                    \&quot;MainUri\&quot;: \&quot;http://example.com\&quot;,                    \&quot;RegistrationUri\&quot;: null,                    \&quot;RequirePkce\&quot;: false,                    \&quot;Switch\&quot;: false                }
     * @param appId 
     * @param applicationRequest The Application Request.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsAppIdPut(appId: string, applicationRequest?: ApplicationRequest, observe?: 'body', reportProgress?: boolean): Observable<Application>;
    public applicationsAppIdPut(appId: string, applicationRequest?: ApplicationRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Application>>;
    public applicationsAppIdPut(appId: string, applicationRequest?: ApplicationRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Application>>;
    public applicationsAppIdPut(appId: string, applicationRequest?: ApplicationRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling applicationsAppIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Application>(`${this.configuration.basePath}/Applications/${encodeURIComponent(String(appId))}`,
            applicationRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applications - Update Services
     * This is for Updating the Services for an Application                Sample request:                PUT /applications/{appId}/services                [\&quot;\&quot;]
     * @param appId The application Id.
     * @param requestBody The service Ids.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsAppIdServicesPut(appId: string, requestBody?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Application>;
    public applicationsAppIdServicesPut(appId: string, requestBody?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Application>>;
    public applicationsAppIdServicesPut(appId: string, requestBody?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Application>>;
    public applicationsAppIdServicesPut(appId: string, requestBody?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling applicationsAppIdServicesPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Application>(`${this.configuration.basePath}/Applications/${encodeURIComponent(String(appId))}/services`,
            requestBody,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applications - By ClientId
     * This is for getting the Application by ClientId                Sample request:                GET /applications/clientId/lowes-integration
     * @param clientId The client id.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsClientIdClientIdGet(clientId: string, observe?: 'body', reportProgress?: boolean): Observable<Application>;
    public applicationsClientIdClientIdGet(clientId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Application>>;
    public applicationsClientIdClientIdGet(clientId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Application>>;
    public applicationsClientIdClientIdGet(clientId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (clientId === null || clientId === undefined) {
            throw new Error('Required parameter clientId was null or undefined when calling applicationsClientIdClientIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Application>(`${this.configuration.basePath}/Applications/clientId/${encodeURIComponent(String(clientId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applications - All
     * This is for getting all the Applications Page 1 PageSize 500                Sample request:                GET /applications
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ApplicationSearchResult>>;
    public applicationsGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ApplicationSearchResult>>>;
    public applicationsGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ApplicationSearchResult>>>;
    public applicationsGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ApplicationSearchResult>>(`${this.configuration.basePath}/Applications`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applications - List By Username
     * This is for getting the Applications by Username                Sample request:                POST /applications/list-user-applications
     * @param userApplicationsRequest The UserApplicationsRequest.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsListUserApplicationsPost(userApplicationsRequest?: UserApplicationsRequest, observe?: 'body', reportProgress?: boolean): Observable<Application>;
    public applicationsListUserApplicationsPost(userApplicationsRequest?: UserApplicationsRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Application>>;
    public applicationsListUserApplicationsPost(userApplicationsRequest?: UserApplicationsRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Application>>;
    public applicationsListUserApplicationsPost(userApplicationsRequest?: UserApplicationsRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Application>(`${this.configuration.basePath}/Applications/list-user-applications`,
            userApplicationsRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applications - Create
     * This is for creating a new Application                Sample request:                POST /applications                {                    \&quot;ClientId\&quot;: \&quot;sample-id\&quot;,                    \&quot;FlowTypeId\&quot;: 1,                    \&quot;Name\&quot;: \&quot;sample\&quot;,                    \&quot;Description\&quot;: null,                    \&quot;ImageBundleId\&quot;: 1,                    \&quot;GrantTypes\&quot;: [1, 2],                    \&quot;SupportContactEmail\&quot;: null,                    \&quot;ApplicationTypeId\&quot;: 1,                    \&quot;AccessTokenLifetime\&quot;: 50,                    \&quot;AllowOfflineAccess\&quot;: false,                    \&quot;MainUri\&quot;: \&quot;http://example.com\&quot;,                    \&quot;RegistrationUri\&quot;: null,                    \&quot;RequirePkce\&quot;: false,                    \&quot;Switch\&quot;: false                }
     * @param applicationRequest The Application Request.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsPost(applicationRequest?: ApplicationRequest, observe?: 'body', reportProgress?: boolean): Observable<Application>;
    public applicationsPost(applicationRequest?: ApplicationRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Application>>;
    public applicationsPost(applicationRequest?: ApplicationRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Application>>;
    public applicationsPost(applicationRequest?: ApplicationRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Application>(`${this.configuration.basePath}/Applications`,
            applicationRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applications - Search
     * This is for getting the Applications for the grid                Sample request:                POST /applications/search                {                    \&quot;Q\&quot;: null,                    \&quot;Page\&quot;: \&quot;1\&quot;                }
     * @param searchRequest The search Request.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsSearchPost(searchRequest?: SearchRequest, observe?: 'body', reportProgress?: boolean): Observable<ApplicationSearchResults>;
    public applicationsSearchPost(searchRequest?: SearchRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApplicationSearchResults>>;
    public applicationsSearchPost(searchRequest?: SearchRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApplicationSearchResults>>;
    public applicationsSearchPost(searchRequest?: SearchRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApplicationSearchResults>(`${this.configuration.basePath}/Applications/search`,
            searchRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applications - Applications by UserId
     * This is for getting the list of Applications by UserId                Sample request:                GET /applications/user/{userId}
     * @param userId The user guid id.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsUserUserIdGet(userId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ApplicationSearchResult>>;
    public applicationsUserUserIdGet(userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ApplicationSearchResult>>>;
    public applicationsUserUserIdGet(userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ApplicationSearchResult>>>;
    public applicationsUserUserIdGet(userId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling applicationsUserUserIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ApplicationSearchResult>>(`${this.configuration.basePath}/Applications/user/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// /ng-app/src/apiModule/api/applications.service.ts